// ============================================================
// @munawb/supabase — Supabase Client
// مُهيَّأ مرة واحدة ويُستخدم في كل مكان
// ============================================================

import { createClient } from '@supabase/supabase-js';

// هذه المتغيرات تُقرأ من بيئة التشغيل
// في apps/web: من import.meta.env (Vite)
// في apps/mobile: من expo-constants
const SUPABASE_URL     = (typeof import.meta !== 'undefined'
  ? (import.meta as { env?: { VITE_SUPABASE_URL?: string } }).env?.VITE_SUPABASE_URL
  : process.env['SUPABASE_URL']) ?? '';

const SUPABASE_ANON_KEY = (typeof import.meta !== 'undefined'
  ? (import.meta as { env?: { VITE_SUPABASE_ANON_KEY?: string } }).env?.VITE_SUPABASE_ANON_KEY
  : process.env['SUPABASE_ANON_KEY']) ?? '';

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('[Munawb] Supabase URL and Anon Key must be set in environment variables.');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken:    true,
    persistSession:      true,
    detectSessionInUrl:  true,
    flowType:            'implicit',
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});

// تصدير النوع للاستخدام في TypeScript generics
export type SupabaseClient = typeof supabase;
